<template>
  <div class="mobile-back-btn-secondary-nav-container">

    <download-selected-btn></download-selected-btn>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import DownloadSelectedBtn from "../Elements/DownloadSelectedBtn.vue";

export default {
  name: "MobileFilesNavbar",
  props: {},
  components: {DownloadSelectedBtn},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
.download-btn-main {
  padding: 0 20px;
}
.download-btn-dropdown {
  border-left: 2px solid #1158cd;
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
}
.download-btn {
  padding: 0;
  background: #1266F1;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background: #1161e5;
  }
}




.mobile-back-btn-secondary-nav-container {
  border-top: 1px solid #CBCBCB;
  background: white;
  padding: 10px 20px!important;

  .mobile-back-btn-secondary-nav {
    background: #1266F1;
    color: white;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    gap: 10px;
    font-size: 17.5px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      background: #1161e5;
    }
  }
}
</style>
